import { render, staticRenderFns } from "./UploadKYCDocs.vue?vue&type=template&id=af8c298a&scoped=true"
import script from "./UploadKYCDocs.vue?vue&type=script&lang=js"
export * from "./UploadKYCDocs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8c298a",
  null
  
)

export default component.exports